import React from 'react';
import { formatMoneyForLocale, useI18n } from '@stitch-fix/i18n';
import { Text, Inline, Box, StickerLabel } from '@stitch-fix/mode-react';
import PropTypes from 'prop-types';

const Price = ({
  value,
  priceMarkdown,
}: {
  value: string;
  priceMarkdown?: {
    amount?: {
      value: string | number;
      currency: string;
    };
    discountLabel?: string;
    fullPrice: {
      value: number;
      currency: string;
    };
    percentage?: number;
  } | null;
}) => {
  const { locale } = useI18n();

  const isDiscountPricing = !!priceMarkdown;

  return (
    <Inline data-testid="price-component" spacing={0.5}>
      <Text
        color={isDiscountPricing ? 'red-40' : 'gray-16'}
        as="div"
        height="standard"
        family="medium"
        scale="5"
      >
        {value}
      </Text>
      {isDiscountPricing && (
        <Inline data-testid="markdown-section" spacing={0.5}>
          <Box>
            <Text
              color="gray-55"
              as="div"
              height="standard"
              family="medium"
              scale="5"
              style={{ textDecoration: 'line-through' }}
            >
              {formatMoneyForLocale(locale, priceMarkdown?.fullPrice, {
                subunits: true,
              })}
            </Text>
          </Box>
          <StickerLabel mt={0.125} variant="error">
            {priceMarkdown?.discountLabel ||
              `${priceMarkdown?.percentage}% off`}
          </StickerLabel>
        </Inline>
      )}
    </Inline>
  );
};

Price.propTypes = {
  value: PropTypes.string,
  priceMarkdown: PropTypes.shape({
    fullPrice: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.string,
    }),
    discountLabel: PropTypes.string,
    percentage: PropTypes.number,
    amount: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.string,
    }),
  }),
};

Price.defaultProps = {
  value: undefined,
  priceMarkdown: null,
};

export default Price;
